export class AddToBasketApi {

    initialized = false;

    async addToBasket(data: AddToBasketData) {
        const response = await fetch('/order/addToBasket', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                variationId: data.variationId,
                itemOrigin: data.itemOrigin,
                quantity: data.quantity,
                tracking: data.tracking
            })
        });
        let successful;
        /*🤫*/
        const responseData = await response.text()
            .then((text) => window.o_order.utils.parseJson(text)) as AddToBasketResponse;
        if (response.status === 201) {
            successful = !responseData.limitReached;
            window.o_order.common.basketChange.triggerBasketChange();
            window.o_order.firebaseBridge.emitAddToBasketEvent(responseData);
        } else {
            successful = false;
        }
        if (responseData && 'eventMergeId' in responseData) {
            window.o_order.tracking.submitDummyEventMerge('add', responseData.eventMergeId);
        }
        window.o_global.eventQBus.emit('ft1.order-core.addToBasketResult', {
            variationId: data.variationId,
            successful,
            eventMergeId: responseData.eventMergeId
        });
    }

    init(): void {
        window.o_global.eventQBus.on('ft1.order-core.addToBasket', (data: AddToBasketData) => {
            this.addToBasket(data);
        });
    }
}

interface AddToBasketResponse {
    limitReached: boolean;
    eventMergeId: string;
    articleNumber: string;
    itemName: string;
    itemCategory: string;
    addedQuantity: number;
}

interface AddToBasketData {
    variationId: string;
    itemOrigin: string;
    quantity: number;
    services?: unknown;
    tracking?: unknown;
}
